<template>
<div></div>
</template>

<script>
import * as Api from '@api/base/public'
export default {
  name: 'Transfer',
  data() {
    return {
      shop: ''
    }
  },
  async created() {
    const { hmac = '', shop = '', host = '' } = this.$route.query
    if (hmac && shop && host) {
      this.shop = shop.replace('.myshopify.com', '')
      const shopifyAuthTime = sessionStorage.getItem('shopifyAuthTime')
      if (shopifyAuthTime && new Date().getTime() - shopifyAuthTime <= 3000) {
        // 5s内重复请求就结束
        return false
      }
      sessionStorage.setItem('shopifyAuthTime', new Date().getTime())
      const res = await this.shopifyCheckSign(this.$route.query)
      if (!res) {
        // 校验失败  请求真实性异常
        this.$message.error('invalid request')
        location.href = `https://${shop}`
      }
    }
    this.init()
  },
  methods: {
    async shopifyCheckSign(params) {
      const { data = false } = await Api.shopifyCheckSign(params)
      return data
    },
    // 初始化
    init() {
      // shopify 生产使用key
      let id = '506ac36d5a214328c00d76f35f6a62ab'
      if (location.host !== 'vip.jtjms-mx.com') {
        // shopify 非生产使用key
        id = '60189d602fae67c96185322f2748e5bb'
      }
      console.log(this.shop)
      location.href = `https://${this.shop}.myshopify.com/admin/oauth/authorize?client_id=${id}&scope=read_locations,write_fulfillments,write_orders,write_shipping&redirect_uri=${
        location.origin
      }/shopifylogin`
    }
  }
}
</script>

<style>

</style>
